module.exports = __webpack_public_path__ + "img/bg-banner2.34ca680a.jpeg";